"use client";

import { c as _c } from "react/compiler-runtime";
import { NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuTrigger } from "@/components/ui/navigation-menu";
import { trackNavItemClicked } from "@/lib/analytics/segment";
import { getNavItemChildren, type NavItemEntry, navItemDestination, navItemUrl } from "@/lib/contentful/navItem";
import { CmsLink } from "./CmsLink";
import { NavDropdown } from "./NavDropdown";
import { NavMegaMenu } from "./NavMegaMenu";
interface Props {
  item: NavItemEntry;
}
const linkClass = "px-3 py-2 text-center text-sm font-medium no-underline! hover:opacity-100!";
export function NavItem(t0) {
  const $ = _c(30);
  const {
    item
  } = t0;
  const {
    title,
    isNewTab
  } = item.fields;
  let children;
  let linkHref;
  let t1;
  let t2;
  if ($[0] !== isNewTab || $[1] !== item || $[2] !== title) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      children = getNavItemChildren(item);
      if (children.length === 0) {
        let t3;
        if ($[7] !== item) {
          t3 = navItemDestination(item);
          $[7] = item;
          $[8] = t3;
        } else {
          t3 = $[8];
        }
        let t4;
        if ($[9] !== title) {
          t4 = href => trackNavItemClicked({
            label: title,
            destinationUrl: href,
            level: 1
          });
          $[9] = title;
          $[10] = t4;
        } else {
          t4 = $[10];
        }
        let t5;
        if ($[11] !== isNewTab || $[12] !== t3 || $[13] !== t4 || $[14] !== title) {
          t5 = <NavigationMenuItem><NavigationMenuLink asChild={true}><CmsLink destination={t3} isNewTab={isNewTab} className={linkClass} onNavigate={t4}>{title}</CmsLink></NavigationMenuLink></NavigationMenuItem>;
          $[11] = isNewTab;
          $[12] = t3;
          $[13] = t4;
          $[14] = title;
          $[15] = t5;
        } else {
          t5 = $[15];
        }
        t2 = t5;
        break bb0;
      }
      let t3;
      if ($[16] !== item) {
        t3 = navItemUrl(item);
        $[16] = item;
        $[17] = t3;
      } else {
        t3 = $[17];
      }
      linkHref = t3;
      t1 = children.some(_temp);
    }
    $[0] = isNewTab;
    $[1] = item;
    $[2] = title;
    $[3] = children;
    $[4] = linkHref;
    $[5] = t1;
    $[6] = t2;
  } else {
    children = $[3];
    linkHref = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  const isMegaMenu = t1;
  let t3;
  if ($[18] !== linkHref || $[19] !== title) {
    t3 = () => trackNavItemClicked({
      label: title,
      destinationUrl: linkHref,
      level: 1
    });
    $[18] = linkHref;
    $[19] = title;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== t3 || $[22] !== title) {
    t4 = <NavigationMenuTrigger className="bg-transparent text-sm font-medium hover:bg-accent data-[state=open]:bg-accent" onClick={t3}>{title}</NavigationMenuTrigger>;
    $[21] = t3;
    $[22] = title;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== children || $[25] !== isMegaMenu) {
    t5 = <NavigationMenuContent>{isMegaMenu ? <NavMegaMenu columns={children} /> : <NavDropdown items={children} />}</NavigationMenuContent>;
    $[24] = children;
    $[25] = isMegaMenu;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== t4 || $[28] !== t5) {
    t6 = <NavigationMenuItem>{t4}{t5}</NavigationMenuItem>;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  return t6;
}
function _temp(c) {
  return getNavItemChildren(c).length > 0;
}